export default __webpack_public_path__ + "static/media/28.60d2f3a4.jpg";